<template>
    <!-- Begin:PageContent-FlightplanTable -->
    <section id="content">
        <div class="container flight-detail-page">
            <div class="row">
                <div id="main" class="col-md-9">
                    <div class="tab-container style1 box" id="flight-main-content">
                        <ul class="tabs">
                            <li  class="active">
                                <a data-toggle="tab" href="#summer-tab2">{{ summerflightplan[getCurrentLocale] }} 2020</a>
                            </li>
                            <li>
                                <a data-toggle="tab" href="#winter-tab2">{{ winterflightplan[getCurrentLocale] }} 2020/21</a>
                            </li>
                            <li class="pull-right">
                                <a class="button btn-small yellow-bg white-color" @click.prevent="onClick_ResetMap()">{{ reset[getCurrentLocale] }}</a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div id="summer-tab2" class="tab-pane fade in active">
                                <div class="panel panel-default" style="margin-bottom: 0px; border: 0px;">
                                    <!-- Sommer-Flugplan 2020 -->
                                    <div class="panel-heading" role="tab" id="headingSixeFp">
                                        <h4 class="panel-title">
                                            <i class="fa fa-info-circle" style="margin-right:10px;"></i>
                                            <a
                                                class="collapsed"
                                                role="button"
                                                data-toggle="collapse"
                                                data-parent="#accordion2"
                                                href="#collapseSixFp"
                                                aria-expanded="false"
                                                aria-controls="collapseSixFp"
                                            >{{ summerflightplan[getCurrentLocale] }} 2020</a>
                                        </h4>
                                    </div>
                                    <div id="collapseSixFp" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingSixeFp">
                                        <div class="panel-body">
                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Berlin-Tegel (TXL)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%" >{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Beirut</th>
                                                            <td>
                                                                <center>01.07.2020 - 23.09.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">&nbsp;</th>
                                                            <td>
                                                                <center>01.07.2020 - 30.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Burgas</th>
                                                            <td>
                                                                <center>01.07.2020 - 23.09.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Heraklion</th>
                                                            <td>
                                                                <center>04.07.2020 - 31.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Kos</th>
                                                            <td>
                                                                <center>02.07.2020 - 29.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Rhodos</th>
                                                            <td>
                                                                <center>02.07.2020 - 31.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Korfu</th>
                                                            <td>
                                                                <center>04.07.2020 - 27.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Varna</th>
                                                            <td>
                                                                <center>06.07.2020 - 21.09.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a class="button btn-small yellow-bg white-color pull-right" @click.prevent="onClick_DepartureAirport({ depairport: 'TXL_SUMMER_20' })">{{ seeonmap[getCurrentLocale] }}</a>





                                            <br />
                                            <br />
                                            <br />
                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Kassel-Calden (KSF)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%" >{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Heraklion</th>
                                                            <td>
                                                                <center>04.07.2020 – 31.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Palma de Mallorca</th>
                                                            <td>
                                                                <center>06.07.2020– 30.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Antalya</th>
                                                            <td>
                                                                <center>18.07.2020 – 29.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a class="button btn-small yellow-bg white-color pull-right" @click.prevent="onClick_DepartureAirport({ depairport: 'KSF_SUMMER_20' })">{{ seeonmap[getCurrentLocale] }}</a>






                                            <br />
                                            <br />
                                            <br />
                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Dresden (DRS)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%">{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Antalya</th>
                                                            <td>
                                                                <center>17.07.2020 - 30.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Fuerteventura</th>
                                                            <td>
                                                                <center>23.07.2020 - 29.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Heraklion</th>
                                                            <td>
                                                                <center>12.07.2020 - 25.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">&nbsp;</th>
                                                            <td>
                                                                <center>12.07.2020 - 30.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>


                                                        <tr>
                                                            <th scope="row">Korfu</th>
                                                            <td>
                                                                <center>21.07.2020 - 27.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Kos</th>
                                                            <td>
                                                                <center>19.07.2020 - 01.11.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Palma de Mallorca</th>
                                                            <td>
                                                                <center>18.07.2020 - 31.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Rhodos</th>
                                                            <td>
                                                                <center>04.07.2020 - 31.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Varna</th>
                                                            <td>
                                                                <center>18.07.2020 - 24.08.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">&nbsp;</th>
                                                            <td>
                                                                <center>18.07.2020 - 26.09.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a class="button btn-small yellow-bg white-color pull-right" @click.prevent="onClick_DepartureAirport({ depairport: 'DRS_SUMMER_20' })">{{ seeonmap[getCurrentLocale] }}</a>





                                            <br />
                                            <br />
                                            <br />
                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Bremen (BRE)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%">{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Antalya</th>
                                                            <td>
                                                                <center>15.07.2020 - 28.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Fuerteventura</th>
                                                            <td>
                                                                <center>17.07.2020 - 30.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Heraklion</th>
                                                            <td>
                                                                <center>04.07.2020 - 27.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Kos</th>
                                                            <td>
                                                                <center>16.07.2020 - 29.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Palma de Mallorca</th>
                                                            <td>
                                                                <center>17.07.2020 - 25.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">&nbsp;</th>
                                                            <td>
                                                                <center>17.07.2020 - 30.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Rhodos</th>
                                                            <td>
                                                                <center>14.07.2020 - 27.10.2020</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a class="button btn-small yellow-bg white-color pull-right" @click.prevent="onClick_DepartureAirport({ depairport: 'BRE_SUMMER_20' })">{{ seeonmap[getCurrentLocale] }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div id="winter-tab2" class="tab-pane fade">
                                <div class="panel panel-default" style="margin-bottom: 0px; border: 0px;">
                                    <!-- Winter-Flugplan 2020/21 -->
                                    <div class="panel-heading" role="tab" id="headingSixeFp2">
                                        <h4 class="panel-title">
                                            <i class="fa fa-info-circle" style="margin-right:10px;"></i>
                                            <a
                                                class="collapsed"
                                                role="button"
                                                data-toggle="collapse"
                                                data-parent="#accordion2"
                                                href="#collapseSixFp1"
                                                aria-expanded="false"
                                                aria-controls="collapseSixFp2"
                                            >{{ winterflightplan[getCurrentLocale] }} 2020/21</a>
                                        </h4>
                                    </div>
                                    <div id="collapseSixFp2" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingSixeFp2">
                                        <div class="panel-body">

                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Berlin-Brandenburg (BER)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%" >{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Hurghada</th>
                                                            <td>
                                                                <center>03.11.20 - 27.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Gran Canaria</th>
                                                            <td>
                                                                <center>07.11.20 - 24.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Beirut</th>
                                                            <td>
                                                                <center>06.11.20 - 26.03.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a class="button btn-small yellow-bg white-color pull-right" @click.prevent="onClick_DepartureAirport({ depairport: 'BER_WINTER_21' })">{{ seeonmap[getCurrentLocale] }}</a>


                                            <br />
                                            <br />
                                            <br />
                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Bremen (BRE)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%" >{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Fuerteventura</th>
                                                            <td>
                                                                <center>03.11.20 - 27.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Hurghada</th>
                                                            <td>
                                                                <center>18.12.20 - 30.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Gran Canaria</th>
                                                            <td>
                                                                <center>05.11.20 - 12.12.20</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                       <tr>
                                                            <th scope="row">&nbsp;</th>
                                                            <td>
                                                                <center>13.12.20 - 29.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Teneriffa Süd</th>
                                                            <td>
                                                                <center>18.11.20 - 28.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a class="button btn-small yellow-bg white-color pull-right" @click.prevent="onClick_DepartureAirport({ depairport: 'BRE_WINTER_21' })">{{ seeonmap[getCurrentLocale] }}</a>


                                            <br />
                                            <br />
                                            <br />
                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Dresden (DRS)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%" >{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Fuerteventura</th>
                                                            <td>
                                                                <center>03.11.20 - 27.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Hurghada</th>
                                                            <td>
                                                                <center>18.12.20 - 30.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Gran Canaria</th>
                                                            <td>
                                                                <center>05.11.20 - 12.12.20</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">&nbsp;</th>
                                                            <td>
                                                                <center>13.12.20 - 29.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Teneriffa Süd</th>
                                                            <td>
                                                                <center>18.11.20 - 28.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a class="button btn-small yellow-bg white-color pull-right" @click.prevent="onClick_DepartureAirport({ depairport: 'DRS_WINTER_21' })">{{ seeonmap[getCurrentLocale] }}</a>


                                            <br />
                                            <br />
                                            <br />
                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Düsseldorf (DUS)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%" >{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Lanzarote</th>
                                                            <td>
                                                                <center>21.12.20 - 04.01.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td><center>x</center></td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Fuerteventura</th>
                                                            <td>
                                                                <center>20.12.20 - 03.01.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Hurghada</th>
                                                            <td>
                                                                <center>22.12.20 - 05.01.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Gran Canaria</th>
                                                            <td>
                                                                <center>19.12.20 - 02.01.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Teneriffa Süd</th>
                                                            <td>
                                                                <center>23.12.20 - 06.01.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Beirut</th>
                                                            <td>
                                                                <center>01.10.20 - 04.12.20</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td><center>x</center></td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">&nbsp;</th>
                                                            <td>
                                                                <center>05.12.20 - 25.03.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a class="button btn-small yellow-bg white-color pull-right" @click.prevent="onClick_DepartureAirport({ depairport: 'DUS_WINTER_21' })">{{ seeonmap[getCurrentLocale] }}</a>


                                            <br />
                                            <br />
                                            <br />
                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Kassel (KSF)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%" >{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Fuerteventura</th>
                                                            <td>
                                                                <center>07.11.20 - 24.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Hurghada</th>
                                                            <td>
                                                                <center>22.12.20-27.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td><center>x</center></td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Gran Canaria</th>
                                                            <td>
                                                                <center>28.11.20 - 25.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td><center>x</center></td>
                                                            <!-- So -->
                                                            <td><center>x</center></td>

                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Teneriffa Süd</th>
                                                            <td>
                                                                <center>04.11.20 - 28.04.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td><center>x</center></td>
                                                            <!-- Do -->
                                                            <td>&nbsp;</td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a class="button btn-small yellow-bg white-color pull-right" @click.prevent="onClick_DepartureAirport({ depairport: 'KSF_WINTER_21' })">{{ seeonmap[getCurrentLocale] }}</a>


                                            <br />
                                            <br />
                                            <br />
                                            <h5 style="margin-top: 20px;">
                                                <i class="fa fa-map-marker" style="margin-right:10px;"></i>Beirut (BEY)
                                            </h5>
                                            <div class="table-responsive">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th width="30%" >{{ destinationairport[getCurrentLocale] }}</th>
                                                            <th>&nbsp;</th>
                                                            <th>
                                                                <center>{{ monday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ tuesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ wednesday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ thursday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ friday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ saturday[getCurrentLocale] }}</center>
                                                            </th>
                                                            <th>
                                                                <center>{{ sunday[getCurrentLocale] }}</center>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Stockholm/Arlanda</th>
                                                            <td>
                                                                <center>10.12.20 - 25.03.21</center>
                                                            </td>

                                                            <!-- Mo -->
                                                            <td>&nbsp;</td>
                                                            <!-- Di -->
                                                            <td>&nbsp;</td>
                                                            <!-- Mi -->
                                                            <td>&nbsp;</td>
                                                            <!-- Do -->
                                                            <td><center>x</center></td>
                                                            <!-- Fr -->
                                                            <td>&nbsp;</td>
                                                            <!-- Sa -->
                                                            <td>&nbsp;</td>
                                                            <!-- So -->
                                                            <td>&nbsp;</td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Begin:Content-SideBar-FlightplanTable -->
                <div class="sidebar col-md-3">
                    <sdr-aboutsundair-box></sdr-aboutsundair-box>
                    <sdr-contact-box></sdr-contact-box>
                </div>
                <!-- End:Content-SideBar-FlightplanTable -->
            </div>
        </div>
    </section>
    <!-- End:PageContent-FlightplanTable -->
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                headlinecontent: {
                    en: 'Discover our best destinations',
                    de: 'Entdecken Sie unsere besten Reiseziele',
                },
                reset: {
                    en: 'Reset Map',
                    de: 'Reset Karte',
                },
                seeonmap: {
                    en: 'Show flight destinations on map',
                    de: 'Zeige Flugziele auf Karte',
                },
                from: {
                    en: 'from',
                    de: 'ab',
                },
                flight: {
                    en: 'Flight',
                    de: 'Flug',
                },
                summerflightplan: {
                    en: 'Summer timetable',
                    de: 'Sommer-Flugplan',
                },
                winterflightplan: {
                    en: 'Winter timetable',
                    de: 'Winter-Flugplan',
                },
                monday: {
                    en: 'Mon',
                    de: 'Mo',
                },
                tuesday: {
                    en: 'Tue',
                    de: 'Di',
                },
                wednesday: {
                    en: 'Wed',
                    de: 'Mi',
                },
                thursday: {
                    en: 'Thu',
                    de: 'Do',
                },
                friday: {
                    en: 'Fri',
                    de: 'Fr',
                },
                saturday: {
                    en: 'Sat',
                    de: 'Sa',
                },
                sunday: {
                    en: 'Sun',
                    de: 'So',
                },
                destinationairport: {
                    en: 'Destination Airport',
                    de: 'Zielflughafen',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Utilities'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * onClick_DepartureAirport()
            *
            * Desc:
            * Note: Emitt Event here (Parent is listening).
            *
            * @param {Object} depairport (The Departure Airport)
            */
            onClick_DepartureAirport(depairport) {

                let me = this;


                me.$toc('>>> /flightplan/pagecontent/FlightplanTable.vue >>> onClick_DepartureAirport');
                this.$emit('clickdepartureairport', depairport);

            }, // eof onClick_DepartureAirport()


            /*******************************************************************
            * onClick_ResetMap()
            *
            * Desc:
            * Note: Emitt Event here (Parent is listening).
            *
            */
            onClick_ResetMap() {

                let me = this;


                me.$toc('>>> /flightplan/pagecontent/FlightplanTable.vue >>> onClick_ResetMap');
                this.$emit('clickresetmap');

            }, // eof onClick_ResetMap()

        }, // eof methods()
        /* <<< ****************************************************************/
    };
</script>

<style scoped>
#summer-tab,
#summer-tab,
#winter-tab {
    background: #fff;
    padding: 3px 3px !important;
}
</style>


